<template>
  <div
    class="asc-notification-wrapper"
    :class="{
      multipleNotifications:
        notifications && notifications.length && notifications.length > 1,
    }"
  >
    <transition
      v-for="(notification, rIndex) in notifications"
      :key="rIndex"
      :name="getAnimationName(notification)"
    >
      <div
        v-if="notification.isActive"
        class="asc-notification"
        :class="[
          notification.mode && notification.mode === 'toast'
            ? 'toast'
            : 'alert',
          notification.mode && notification.mode === 'toast'
            ? notification.position && notification.position === 'top'
              ? 'top'
              : 'bottom'
            : '',
          notification.dismissible === false ? '' : 'dismissible',
          notification.isActive ? 'active' : '',
          getColor(notification),
          notification.uppercase ? 'text-uppercase' : null,
        ]"
      >
        <div
          role="alert"
          class="wrapper"
          :class="[notification.multiLine ? 'multi-line' : '']"
        >
          <div v-if="notification.type" class="icon-container">
            <v-icon dark size="16">
              {{ getIcon(notification) }}
            </v-icon>
          </div>
          <div
            class="content-wrapper"
            :class="[
              notification.mode === 'toast' ? 'toast-content-wrapper' : '',
            ]"
          >
            <div class="content" v-html="notification.text"></div>
            <div
              v-if="notification.link"
              class="link-text"
              @click="handleLinkClick"
            >
              {{ notification.link }}
            </div>
          </div>
          <button
            v-if="notification.mode === 'toast' && notification.hasToastAction"
            type="button"
            class="toast-action"
            @click="handleToastActionClick(notification)"
          >
            {{
              notification.toastActionLabel
                ? notification.toastActionLabel
                : 'Click'
            }}
          </button>
          <v-btn
            v-if="notification.dismissible !== false"
            text
            class="close"
            dark
            @click="handleClose(notification)"
          >
            <v-icon size="16">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AscNotification',
  components: {},
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    onToastAction: {
      type: Function,
      default: () => {},
    },
    definition: {
      type: Array,
      required: true,
    },
    queue: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      defaultAutoCloseDuration: 3000,
    }
  },
  computed: {
    notifications() {
      if (this.definition && this.definition.length) {
        return _.map(this.definition, o => _.extend({ isActive: false }, o))
      }
      return []
    },
  },

  beforeMount() {
    // eslint-disable-next-line
    this.notifications.map(notification => {
      this.showNotificaton(notification)
    })
  },

  methods: {
    handleLinkClick() {
      this.$emit('onLinkClick')
    },
    getAnimationName(notification) {
      return notification && notification.mode === 'toast'
        ? notification.position && notification.position === 'top'
          ? 'toast-top'
          : 'toast-bottom'
        : 'alert'
    },
    getColor(notification) {
      if (notification && notification.color) {
        const validColor = notification.color.match(
          /primary|error|warning|notice|success/g,
        )
        return `notification--${
          notification.color && validColor ? notification.color : 'primary'
        }`
      } else if (notification.icongreen) {
        return `notification--icongreen`
      }
      return `notification--primary`
    },
    getIcon(notification) {
      return notification.icon
        ? notification.icon
        : notification.type === 'standard'
        ? 'mdi-information'
        : notification.type === 'success'
        ? 'mdi-check'
        : notification.type === 'error'
        ? 'mdi-alert-circle'
        : notification.type === 'notice'
        ? 'mdi-alert-circle-outline'
        : notification.type === 'warning'
        ? 'mdi-alert'
        : ''
    },
    showNotificaton(notification) {
      if (notification.mode === 'toast') {
        if (this.inQueue(notification)) {
          setTimeout(() => this.showNotificaton(notification), 1000)
          return
        }
        if (notification.autoClose) {
          notification.timer = setTimeout(
            () => this.handleClose(notification),
            notification.duration
              ? notification.duration
              : this.defaultAutoCloseDuration,
          )
        }
      }
      notification.isActive = true
    },
    handleClose(notification) {
      if (!notification.isActive) {
        return
      }
      if (notification.mode === 'toast' && notification.autoClose) {
        clearTimeout(notification.timer)
      }
      notification.isActive = false
      if (this.onClose) this.onClose(notification)
    },
    handleToastActionClick(item) {
      if (item.hasToastAction) {
        item.isActive = false
        this.onToastAction(item)
      }
    },
    inQueue(notification) {
      if (notification && !this.queue) return false
      return this.isToastVisible() > 0
    },
    isToastVisible() {
      const groupedNotification = _.groupBy(this.notifications, 'mode')
      const totalVisibleToast = _.countBy(groupedNotification.toast, 'isActive')
      return totalVisibleToast.true
    },
  },
}
</script>

<style lang="scss">
.asc-notification-wrapper {
  &.insidePageContainer {
    padding: 16px 16px 0 16px;
  }

  .asc-notification {
    text-align: left;
    align-items: center;
    color: $primary-white;
    display: flex;
    pointer-events: none;

    &.toast {
      right: 8px;
      left: 8px;
      position: fixed;
      z-index: 1000;

      &.top {
        top: 1px;
      }

      &.bottom {
        bottom: 1px;
      }

      button.toast-action {
        flex: 0 0 auto;
        height: 18px;
        min-width: 32px;
        color: $primary-black;
        font-size: $font-size-md;
        letter-spacing: 0;
        line-height: 18px;
        margin-left: 16px;

        &:active,
        &:focus {
          outline: none;
        }
      }
    }

    &:not(.dismissible) {
      &.toast {
        button.toast-action {
          margin-right: 16px;
        }
      }
    }

    .wrapper {
      align-items: center;
      display: flex;
      margin: 0 auto;
      pointer-events: auto;
      transition: inherit;
      transition-property: opacity, transform;
      min-width: 100%;

      .icon-container {
        align-items: center;
        display: flex;
        color: $primary-white;
        justify-content: center;
        width: 49px;
        min-height: 48px;
        padding: 16px;
      }

      .content-wrapper {
        align-items: center;
        display: flex;
        min-height: 48px;
        justify-content: space-between;
        overflow: hidden;
        padding: 14px 16px 13.2px 16px;
        width: 100%;
        color: $primary-white;
        font-size: $font-size-md;
        letter-spacing: $spacing-xs;
        line-height: 18px;

        &.toast-content-wrapper {
          border-left: none;
        }
        .link-text {
          text-decoration: underline;
          color: black;
          &:hover {
            cursor: pointer;
          }
        }
        .content {
          flex: 1;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      button.close {
        margin: 0 14px 0 0;
        padding: 0;
        min-width: 20px;
        height: 24px;
      }

      &.multi-line {
        .icon-container {
          align-self: stretch;
        }

        .content-wrapper {
          align-self: flex-start;

          .content {
            flex: 1;
            text-overflow: unset;
            overflow: visible;
            white-space: normal;
          }
        }

        button.close {
          margin: 0 10px 0 0;
          align-self: center;
        }
      }

      .v-btn.close {
        .v-icon {
          color: $primary-black;
        }
      }
    }

    &.notification {
      &--primary {
        .wrapper {
          background-color: $accent-0;

          .icon-container {
            background-color: $accent-400;

            .v-icon {
              color: $primary-black;
            }
          }

          .content-wrapper {
            border-color: $accent-300;
            color: $primary-black;
          }
        }
      }

      &--notice {
        .wrapper {
          background-color: $gray-900;

          .content-wrapper {
            border-color: $gray-600;
          }

          button.toast-action {
            color: $primary-white;
          }

          .v-btn.close {
            .v-icon {
              color: $primary-white;
            }
          }
        }
      }

      &--error {
        .wrapper {
          background-color: #f3dbe0;

          .icon-container {
            background-color: #d20532;
          }

          .content-wrapper {
            border-color: #d20532;
            color: $primary-black;
          }
        }
      }

      &--warning {
        .wrapper {
          background-color: $semantic-warning-hover;

          .icon-container {
            background-color: $caution-base;
          }

          .content-wrapper {
            border-color: $caution-base;
            color: $primary-black;
          }
        }
      }

      &--success {
        .wrapper {
          background-color: #caf4d0;

          .icon-container {
            background-color: $semantic-success;
          }

          button.toast-action {
            color: $primary-black;
          }

          .v-btn.close {
            .v-icon {
              color: $primary-black;
            }
          }

          .content-wrapper {
            border-color: $accent-300;
            color: $primary-black;
          }
        }
      }
      &--icongreen {
        .wrapper {
          background-color: $accent-0;

          .icon-container {
            background-color: $gray-900;

            .v-icon {
              color: $accent-300 !important;
            }
          }

          .content-wrapper {
            border-color: $accent-300;
            color: $primary-black;
          }
          .toast-action {
            color: $accent-300 !important;
          }
        }
      }
    }
  }

  /* Animations */
  .alert-enter-active,
  .toast-top-enter-active,
  .toast-bottom-enter-active {
    transition: all 0.3s ease;
  }

  .alert-leave-active {
    transition: opacity 0.5s;
  }

  .toast-top-leave-active,
  .toast-bottom-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .alert-enter,
  .alert-leave-to {
    opacity: 0;
  }

  .toast-top-enter,
  .toast-top-leave-to {
    transform: translateY(-20px);
    opacity: 0;
  }

  .toast-bottom-enter,
  .toast-bottom-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }

  &.multipleNotifications {
    .asc-notification {
      &.alert {
        margin-bottom: 1px;
      }
    }
  }
}

@media only screen and (min-width: 600px) {
  .asc-notification {
    &.toast {
      .wrapper {
        min-width: 490px;
        max-width: 507px;
      }
    }

    &.alert {
      .wrapper {
        width: 944px;
      }
    }
  }
}
</style>
